<template>
    <div id="labor_cost_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="laborCostHeader" v-if="$route.params.id > 0">Update Labor Cost</span>
                    <span class="page-title" id="laborCostHeader" v-else>Add Labor Cost</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backLaborCostList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content term-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="laborCostForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="labor_pricing_type">Type:</label>
                                        <v-select v-model="labor_pricing_type" name="labor_pricing_type" placeholder="Select Type."
                                                label="text" :disabled="true"
                                                :options="laborPricingTypeArr" id="labor_pricing_type" class="close-remove" @input="onTypeSelect($event)">
                                        </v-select>
                                        <div class="field-error">{{labor_pricing_type_error_msg}}</div>
                                    </div>
                                    <template v-if="(isCustomer && isCreatePage == false) || isCustomerContract">
                                        <div class="col form-group">
                                            <label class="control-label require" for="customer_id">Customer:</label>
                                            <v-select v-model="customer_id" name="customer_id" id="customer_id"
                                                label="text" :filterable="false" :options="customerArr"
                                                @search="onSearchCustomer"
                                                placeholder="Select Customer" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search Customer...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{customer_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-if="isCustomerClass">
                                        <div class="col form-group">
                                            <label class="control-label require" for="customer_class_id">Customer Class:</label>
                                            <v-select v-model="customer_class_id" name="customer_class_id" placeholder="Select Customer Class."
                                                    label="text"
                                                    :options="customerClassArr">
                                            </v-select>
                                            <div class="field-error">{{customer_class_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-if="isCustomerContract">
                                        <div class="col form-group">
                                            <label class="control-label require" for="contract_type_id">Contract Type:</label>
                                            <v-select v-model="contract_type_id" name="contract_type_id" placeholder="Select Contract Type."
                                                    label="text"
                                                    :options="contractTypeArr">
                                            </v-select>
                                            <div class="field-error">{{contract_type_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-if="isUnit && isCreatePage == false">
                                        <div class="col form-group">
                                            <label class="control-label require" for="vehicle_id">Asset:</label>
                                            <v-select v-model="vehicle_id" id="vehicle_id" name="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchAsset" placeholder="Select Asset" class='custom-ci-auto-search close-remove'>
                                                <template slot="no-options">
                                                    Search Asset...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{vehicle_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-if="isLocation">
                                        <div class="col form-group">
                                            <label class="control-label require" for="location_id">Location:</label>
                                            <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" :options="locationArr">
                                            </v-select>
                                            <div class="field-error">{{location_error_msg}}</div>
                                        </div>
                                    </template>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">Cost Code:</label>
                                        <v-select v-model="cost_code" name="cost_code" placeholder="Select Cost Code." label="text" :options="costCodeArr">
                                        </v-select>
                                        <div class="field-error">{{cost_code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="effective_date">Effective Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate"></date-picker>
                                            <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ effective_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="period">Hourly Rate:</label>
                                        <input type="text" class="form-control" 
                                        v-model="hourly_rate" 
                                        @blur="hourly_rate = leaveFocus($event)" 
                                        @focus="hourly_rate = enterVal($event)" id="hourly_rate" placeholder="Enter Hourly Rate" name="hourly_rate" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{hourly_rate_error_msg}}</div>
                                    </div>
                                    <!-- <div class="field-error">{{common_error_msg}}</div> -->
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-col-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                            </form>
                            <template v-if="isCreatePage && isCustomer">
                                <data-table-filter-config :moduleName="'fuelPriceCustomerList'" :key="componentKey" @cancelSelection="cancelAll"></data-table-filter-config>
                                <div class="field-error">{{customer_error_msg}}</div>
                                <section class="bg-white data-table">
                                    <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'fuelPriceCustomerList'" :key="componentKey"  :position="'top'">
                                    </custom-pagination>
                                    <vue-good-table
                                        ref="listFuelReadingCustomerTable"
                                        mode="remote"
                                        title="Customer"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-select-all="onSelectAll"
                                        @on-row-click="onRowClick"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :pagination-options="{
                                            enabled: false,
                                            setCurrentPage:listCurrentPage,
                                            perPage: perPage,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear'
                                        }"
                                        :search-options="{
                                        enabled: false,
                                        }">
                                    </vue-good-table>
                                    <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange"
                                        >
                                    </custom-pagination>
                                </section>
                            </template>
                            <template v-if="isCreatePage && isUnit">
                                <data-table-asset-filter-config :moduleName="'fuelPriceAssetList'" :key="componentKey" ref="filterComponent"></data-table-asset-filter-config>
                                <div class="field-error">{{vehicle_error_msg}}</div>
                                <section class="bg-white data-table">
                                    <custom-asset-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'fuelPriceAssetList'" :key="componentKey" :position="'top'">
                                    </custom-asset-pagination>
                                    <vue-good-table
                                        ref="listFuelReadingVehicleTable"
                                        mode="remote"
                                        title="Asset"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="columnsAsset"
                                        :rows="assetRows"
                                        @on-select-all="onSelectAll"
                                        @on-row-click="onRowClick"
                                        :pagination-options="{
                                            enabled: false,
                                            position: 'both',
                                            setCurrentPage:listCurrentPage,
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                            enabled: false,
                                        }">
                                    </vue-good-table>
                                    <custom-asset-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                    </custom-asset-pagination>
                                </section>
                            </template>
                            <div class="field-error">{{common_error_msg}}</div>
                            <div class="btn-groups">
                                <button type="submit" id="CreateLaborCostBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="createLaborCost" >
                                <i class="fp-reload"> </i>  Update
                                </button>
                                <button type="submit" id="CreateLaborCostBtn" v-else class="btn btn-primary" v-on:click.prevent="createLaborCost" >
                                <i class="fp-save"> </i>  Save
                                </button>
                                <button type="submit" id="createAndContinueLaborCostBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="createLaborCost(flag='Save and Continue')" >
                                <i class="fp-save-continue"> </i>  Save and Continue
                                </button>
                                <button type="submit" id="cancelLaborCostBtn" class="btn btn-tertiary" v-on:click.prevent="backLaborCostList" >
                                <i class="fp-close"> </i>  Cancel
                                </button>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
    name: "LaborCostCreate",
    components: {
            
            customAssetPagination: () => import('@/components/layout/CustomPagination'),
            dataTableAssetFilterConfig: () => import('@/components/DataTableFilterConfig'),
            
        },
    metaInfo() {
        return {title: (this.$route.params.id > 0)? "Update Labor Cost | " +process.env.COPYRIGHT_NAME : "Create Labor Cost | " +process.env.COPYRIGHT_NAME}
    },
    mixins:[commonMixins,contractMixins,dataTableMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        location_id:"",
        cost_code:"",
        effective_date:"",
        hourly_rate:"",
        location_error_msg:"",
        cost_code_error_msg:"",
        effective_date_error_msg:"",
        hourly_rate_error_msg:"",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        locationArr:[],
        costCodeArr:[],
        common_error_msg:"",
        // labor_pricing_type:{
        //     text: "Customer Override",
        //     value: "customer_override"
        // },
        labor_pricing_type:"",
        labor_pricing_type_error_msg:"",
        isCustomer:false,
        isCustomerClass:false,
        isCustomerContract:false,
        isUnit:false,
        isLocation:false,
        customer_class_id:"",
        customerClassArr:[],
        customer_class_error_msg:"",
        customer_id:"",
        customerArr:[],
        customer_error_msg:"",
        contract_type_id:"",
        contractTypeArr:[],
        contract_type_error_msg:"",
        vehicle_id:"",
        vehicleArr:[],
        vehicle_error_msg:"",
        isCreatePage:true,
        selectedAssetArray:[],
        selectedCustomerArray:[],
        componentKey:0,
        rows: [],
        totalRecords: 0,
        userColumns:[],
        columns: [
            {
                label: 'Code',
                field: 'code',
                filterable: true,
                fpFieldType:"text",
                width:'140px',
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterFn: this.onColumnFilter,
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Name',
                field: 'name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Email',
                field: 'email',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Phone',
                field: 'work_phone',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Phone", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'City',
                field: 'city',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "City", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'State',
                field: 'state',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "State", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Stage',
                field: 'stage',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Potential', 'Account Pending', 'Credit Denied', 'New', 'Existing'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Created At',
                field: 'created_at',
                fpFieldType:"date",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Unverified','Active', 'Inactive'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Outstanding AR',
                field: 'outstanding_ar',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Outstanding AR", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        assetRows:[],
        columnsAsset: [
            {
                label: 'Unit',
                field: 'unit_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                width:'90px',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Unit No.", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: 'Name',
                field: 'name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Vin',
                field: 'vin',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "VIN", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Asset Type',
                field: 'asset_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Asset Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Ownership',
                field: 'ownership',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Ownership", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer',
                field: 'customer',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Assigned Facility',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Facility", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Odometer Reading',
                field: 'odometer_reading',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Reading", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Reading Updated At',
                field: 'odometer_reading_time',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Purchase Date',
                field: 'purchase_date',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Date Added',
                field: 'date_added',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Date In Service',
                field: 'date_in_service',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Is Standard',
                field: 'is_standard_unit',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Select Is Standard", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['YES', 'NO'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                hidden:false,
            },
        ]

    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_labor_cost') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
    },
    created: function() {

    },
    mounted: function() {

        var self = this;
        self.getPermissions();
        
        self.isLocation = true;
        self.labor_pricing_type = {
            text: "Location Override",
            value: "location_override"
        };
        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     self.role = userObj.roles[0].name;
            // }

            //set LoggedIn user's location as default location....
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                if ( userObj["locationName"] != undefined && userObj["locationCode"] != undefined ) {
                    self.location_id = {
                        value: userObj["location_id"],
                        text: self.titleCase(userObj["locationName"]) + " | " + userObj["locationCode"]
                    };
                }
            }
        }

        self.loadFieldData(['location','costcode','customerClass','contractType']);

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadLaborCost();
                self.isCreatePage = false;
            }else{
                // self.loadCustomerList();
                // self.loadAssetList();
            }
        }, 100);
    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.listFuelReadingCustomerTable.unselectAllInternal();
        },
        backLaborCostList() {
            var self = this;
            self.$router.push("/labor-cost/list");
        },

        createLaborCost(flag) {
            var self = this;
            var error = false;
            self.location_error_msg = "";
            self.cost_code_error_msg = "";
            self.effective_date_error_msg = "";
            self.hourly_rate_error_msg = "";
            self.common_error_msg = "";
            self.customer_class_error_msg = "";
            self.labor_pricing_type_error_msg = "";
            self.vehicle_error_msg = "";
            self.customer_error_msg = "";
            self.contract_type_error_msg = "";

            if (!self.labor_pricing_type || self.labor_pricing_type == null || self.labor_pricing_type == "") {
                self.labor_pricing_type_error_msg = "Type Require.";
                error = true;
            }

            if (self.isCustomerClass) {
                if (!self.customer_class_id || self.customer_class_id == null || self.customer_class_id == "") {
                    self.customer_class_error_msg = "Customer Class Require.";
                    error = true;
                }
            }

            if ((self.isCustomer && self.isCreatePage == false) || self.isCustomerContract) {
                if (!self.customer_id || self.customer_id == null || self.customer_id == "") {
                    self.customer_error_msg = "Customer Require.";
                    error = true;
                }
            }
            if(self.isCreatePage == true && self.isCustomer && self.isCustomerContract == false){
                if(self.selectedCustomerArray.length <= 0){
                    self.customer_error_msg = "Please Select Customer.";
                    error = true;
                }
            }

            if (self.isUnit && self.isCreatePage == false ) {
                if (!self.vehicle_id || self.vehicle_id == null || self.vehicle_id == "") {
                    self.vehicle_error_msg = "Asset Require.";
                    error = true;
                }
            }
            if(self.isCreatePage == true && self.isUnit){
                if(self.selectedAssetArray.length <= 0){
                    self.vehicle_error_msg = "Please Select Unit.";
                    error = true;
                }
            }
            if (self.isCustomerContract) {
                if (!self.contract_type_id || self.contract_type_id == null || self.contract_type_id == "") {
                    self.contract_type_error_msg = "Contract Type Require.";
                    error = true;
                }
            }

            if (self.isLocation) {
                if (self.location_id == null || !self.location_id.value) {
                    self.location_error_msg = "Location Require.";
                    error = true;
                }
            }

            if (self.cost_code == null || !self.cost_code.value) {
                self.cost_code_error_msg = "Cost Code Require.";
                error = true;
            }

            if (!self.effective_date || self.effective_date == null || self.effective_date == "") {
                self.effective_date_error_msg = "Effective Date Require.";
                error = true;
            }

            if (!self.hourly_rate || self.hourly_rate == null || self.hourly_rate == "" || self.hourly_rate == 0 ) {
                self.hourly_rate_error_msg = "Hourly Rate Require.";
                error = true;
            }

            if (!error) {
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[3])
                {
                    $("#CreateLaborCostBtn").val("Updating ...");
                    $("#CreateLaborCostBtn").prop("disabled", true);
                    $("#cancelLaborCostBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueLaborCostBtn").val("Saving ...");
                        $("#CreateLaborCostBtn").prop("disabled", true);
                        $("#createAndContinueLaborCostBtn").prop("disabled", true);
                        $("#cancelLaborCostBtn").prop("disabled",true);

                    }else{

                        $("#CreateLaborCostBtn").val("Saving ...");
                        $("#CreateLaborCostBtn").prop("disabled", true);
                        $("#createAndContinueLaborCostBtn").prop("disabled", true);
                        $("#cancelLaborCostBtn").prop("disabled",true);
                    }

                }

                var fields = $("#laborCostForm").serializeArray();
                // fields.push({name: "location", value: self.location_id.value});
                fields.push({name: "cost_code", value: self.cost_code.value});
                fields.push({name: "id", value: segments[3]});
                fields.push({name: "type", value: self.labor_pricing_type.value});
                if (self.isCustomer) {
                    if(self.isCreatePage == true){
                        fields.push({name: "customer_id", value: JSON.stringify(self.selectedCustomerArray)});
                    }else{
                        fields.push({name: "customer_id", value: self.customer_id.value});
                    }
                }else if (self.isCustomerClass) {
                    fields.push({name: "customer_class_id", value: self.customer_class_id.value});
                }else if (self.isCustomerContract) {
                    fields.push({name: "customer_id", value: self.customer_id.value});
                    fields.push({name: "contract_type_id", value: self.contract_type_id.value});
                }else if (self.isUnit) {

                    if(self.isCreatePage == true){
                        fields.push({name: "vehicle_id", value: JSON.stringify(self.selectedAssetArray)});
                    }else{
                        fields.push({name: "vehicle_id", value: self.vehicle_id.value});
                    }

                }else if (self.isLocation) {
                    fields.push({name: "location_id", value: self.location_id.value});
                }
                fields.push({name: "hourly_rate", value: self.removeFormat(self.hourly_rate)});

                

                if (segments[3] == undefined) {
                    fields.push({ name: "identifier", value: "create" });
                }else{
                    fields.push({ name: "identifier", value: "update" });
                }

                $.ajax({
                    url: process.env.ROOT_API + "/labor-cost/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#CreateLaborCostBtn").val("Update");
                            $("#CreateLaborCostBtn").prop("disabled", false);
                            $("#cancelLaborCostBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueLaborCostBtn").val("Save and Continue");
                                $("#CreateLaborCostBtn").prop("disabled", false);
                                $("#createAndContinueLaborCostBtn").prop("disabled", false);
                                $("#cancelLaborCostBtn").prop("disabled",false);

                            }else{

                                $("#CreateLaborCostBtn").val("Save");
                                $("#CreateLaborCostBtn").prop("disabled", false);
                                $("#createAndContinueLaborCostBtn").prop("disabled", false);
                                $("#cancelLaborCostBtn").prop("disabled",false);

                            }
                        }
                        if (data.status == "success") {

                            if (flag == "Save and Continue") {

                                $("#laborCostForm").trigger("reset");
                                self.location_id ="";
                                self.cost_code = "";
                                self.effective_date = "";
                                self.hourly_rate = "";
                                self.isCustomer = false;
                                self.isCustomerClass = false;
                                self.isCustomerContract = false;
                                self.isUnit = false;
                                self.isLocation = false;
                                self.customer_id = "";
                                self.customer_class_id = "";
                                self.contract_type_id = "";
                                self.vehicle_id = "";
                                self.labor_pricing_type = {
                                    text: "Location Override",
                                    value: "location_override"
                                };
                                self.selectedCustomerArray = [];
                                self.selectedAssetArray = [];

                            }else{
                                self.$router.push("/labor-cost/list");
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.common_error_msg += data.content[i] + "\n";
                                }
                                // $("#errorMsg").html(err);
                                // $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    // $(".alert-warning").removeClass("show");
                                    // $(".alert-warning").addClass("hide");
                                    self.common_error_msg = "";
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#CreateLaborCostBtn").val("Update");
                            $("#CreateLaborCostBtn").prop("disabled", false);
                            $("#cancelLaborCostBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#laborCostForm").trigger("reset");


                                $("#createAndContinueLaborCostBtn").val("Save and Continue");
                                $("#CreateLaborCostBtn").prop("disabled", false);
                                $("#createAndContinueLaborCostBtn").prop("disabled", false);
                                $("#cancelLaborCostBtn").prop("disabled",false);

                            }else{

                                $("#CreateLaborCostBtn").val("Save");
                                $("#CreateLaborCostBtn").prop("disabled", false);
                                $("#createAndContinueLaborCostBtn").prop("disabled", false);
                                $("#cancelLaborCostBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'labor-cost-create')
                    }
                });
            }else{
                self.errorValidationFocus();
            }
        },

        loadLaborCost() {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/labor-cost/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.labor_pricing_type = {
                            text: data.content.type_text,
                            value: data.content.type
                        };

                        self.cost_code = {text:data.content.cost_code_text,value:data.content.cost_code};
                        self.effective_date = data.content.formatted_date;
                        var hourlyRate = data.content.hourly_rate.toFixed(2);
                        self.hourly_rate = hourlyRate;
                        if (self.labor_pricing_type.value == "customer_override") {
                            self.isCustomer = true;

                            self.customer_id = {
                                text: data.content.custCode + " | " + data.content.custName,
                                value: data.content.customer_id
                            };
                        } else if (self.labor_pricing_type.value == "customer_class_override") {
                            self.isCustomerClass = true;

                            self.customer_class_id = {
                                text: data.content.custClassCode + " | " + data.content.custClassName,
                                value: data.content.customer_class_id
                            };

                        } else if (self.labor_pricing_type.value == "customer_contract_override") {
                            self.isCustomerContract = true;

                            self.labor_pricing_type.text = "Customer/Contract Override";

                            self.customer_id = {
                                text: data.content.custCode + " | " + data.content.custName,
                                value: data.content.customer_id
                            };

                            self.contract_type_id = {
                                text: data.content.contTypeCode + " | " + data.content.contTypeName,
                                value: data.content.contract_type_id
                            };

                        } else if (self.labor_pricing_type.value == "unit_override") {
                            self.isUnit = true;

                            var vehicleData = data.content.unit_no;
                            if(data.content.vtCode != null && data.content.vtCode != ''){
                                vehicleData += " | " + data.content.vtCode;
                            }

                            if(data.content.unit_name != null && data.content.unit_name != ''){
                                vehicleData += " | " + data.content.unit_name;
                            }

                            if(data.content.locName != null && data.content.locName != ''){
                                vehicleData += " | " + data.content.locName;
                            }

                            self.vehicle_id = {
                                text: vehicleData,
                                value: data.content.vehicle_id
                            };
                        } else if (self.labor_pricing_type.value == "location_override") {
                            self.isLocation = true;

                            self.location_id = {text:data.content.loc_name + " | " + data.content.loc_code,value:data.content.location_id};
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'labor-cost-by-id')
                }
            });
        },
        onTypeSelect(event) {
            var self = this;
            var self = this;
            self.isCustomer = false;
            self.isCustomerClass = false;
            self.isCustomerContract = false;
            self.isUnit = false;
            self.isLocation = false;
            self.location_error_msg = "";
            self.cost_code_error_msg = "";
            self.effective_date_error_msg = "";
            self.hourly_rate_error_msg = "";
            self.common_error_msg = "";
            self.customer_class_error_msg = "";
            self.labor_pricing_type_error_msg = "";
            self.customer_error_msg = "";
            self.contract_type_error_msg = "";
            self.vehicle_error_msg = "";
            self.selectedCustomerArray = [];
            self.selectedAssetArray = [];
            setTimeout(function(){
                $('thead tr th:first-child').text('');
            },300);
            if (self.labor_pricing_type != null) {
                if (self.labor_pricing_type.value == "customer_override") {
                    self.isCustomer = true;
                    self.componentKey += 1;
                    self.serverParams.columnFilters=[];
                    self.loadCustomerList();
                } else if (self.labor_pricing_type.value == "customer_class_override") {
                    self.isCustomerClass = true;
                } else if (self.labor_pricing_type.value == "customer_contract_override") {
                    self.isCustomerContract = true;
                }else if (self.labor_pricing_type.value == "unit_override") {
                    self.isUnit = true;
                    self.componentKey += 1;
                    self.serverParams.columnFilters=[];
                    self.loadAssetList();
                } else if (self.labor_pricing_type.value == "location_override") {
                    self.isLocation = true;
                }
            }
        },
        onSearchCustomer(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'customer', '');
            }
        },
        onSearchAsset(search, loading) {
            var self = this;
            if (search.length > 3) {

                loading(true);
                self.searchField(loading, search, 'vehicle', '');
            }
        },
        loadList(){
            var self = this;
        },
        onPageChange(params) {
            var self = this;
            this.updateParams({page: params.currentPage});
            this.listCurrentPage = params.currentPage;
            if(self.isCreatePage && self.isCustomer){
                this.loadCustomerList();
            }
            if(self.isCreatePage && self.isUnit){
                this.loadAssetList();
            }

        },
        onRowClick(params){
            var self = this;
            setTimeout(function(){
                $('.vgt-selection-info-row').css({'display':'none'});
            },1);
                if(self.isCreatePage && self.isCustomer ){
                self.selectedAssetArray = [];
                if ($.inArray(params.row.id, self.selectedCustomerArray) != -1)
                {
                        // self.selectedCustomerArray.splice(i,1);
                    var index = self.selectedCustomerArray.indexOf(params.row.id);
                    if (index > -1) {
                        self.selectedCustomerArray.splice(index, 1);
                    }
                }else{
                    self.selectedCustomerArray.push(params.row.id);
                }
            }
            if(self.isCreatePage && self.isUnit ){
                self.selectedCustomerArray = [];
                if ($.inArray(params.row.id, self.selectedAssetArray) != -1)
                {
                        // self.selectedCustomerArray.splice(i,1);
                    var index = self.selectedAssetArray.indexOf(params.row.id);
                    if (index > -1) {
                        self.selectedAssetArray.splice(index, 1);
                    }
                }else{
                    self.selectedAssetArray.push(params.row.id);
                }
            }
        },
        selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
        findElementIndex(array, attr, value) {
                for(var i = 0; i < array.length; i += 1) {
                    if(array[i][attr] === value) {
                    return i;
                    }
                }
                return -1;
        },
        loadCustomerList() {
            var self = this;

            self.loading = true;

            var selectedRows = [];

            self.serverParams.perPage = 25;

            var fields = {

                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                flag: self.flag,
                selectedRows:selectedRows,
                action:self.action,
                selectedAll:self.serverParams.selectedAll

            };

            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/customer/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;

                        for(var k=0;k< self.rows.length;k++){
                            if ($.inArray(self.rows[k].id, self.selectedCustomerArray) >= 0) {
                                self.$set(self.rows[k], 'vgtSelected', true);
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'customer-list-in-labor-error')

                }
            });
        },
        loadAssetList() {

            var self = this;
            self.loading = true;

            var selectedRows = [];
            self.serverParams.perPage=25;
            //because on first load list not initialize
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    selectedRows:selectedRows,
                    action:self.action,
                    selectedAll:self.serverParams.selectedAll

                };

            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/asset/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        self.assetRows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                        for(var k=0;k< self.assetRows.length;k++){
                            if ($.inArray(self.assetRows[k].id, self.selectedAssetArray) >= 0) {
                                self.$set(self.assetRows[k], 'vgtSelected', true);
                            }
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-asset-list-in-labor-error')
                }
            });
        },
    }

}
</script>



// WEBPACK FOOTER //
// src/components/LaborCostCreate.vue